import React, { useEffect, useRef, useState } from 'react'
import './css/CommunityDetail.css'
import Dialog from '../../../../../lib/Dialog';
import general, { redux } from '../../../../../general';
import { Avatar, ImageViewer } from 'antd-mobile';
import CommunityItem from '../comments/CommunityItem';
import moment from 'moment';
import { BigPlayButton, ControlBar, Player, Shortcut } from 'video-react'
import { useLocalStorageState, useScroll } from 'ahooks';
import { Link } from 'react-router-dom'
import Image from '../../../../../lib/Image';
import ComnunitySort from '../comments/ComnunitySort';
import { NavLink } from '../../../../../lib/Navigation';
import ShareAlert from '../../../../components/alert/ShareAlert';
import PraiseAlert from '../../../../community/PraiseAlert';
import { Popover } from 'antd-mobile';
import useActiveState from '../../../../../lib/useActiveState';
import AuthAlert from '../../../../components/AuthAlert';
import $ from 'jquery';
import { BoxType } from '../../../../../BoxType';

export const monitorSoftKeyboard = callback => {
  const originalHeight = document.documentElement.clientHeight || document.body.clientHeight
  window.addEventListener('resize', () => {
    const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
    if (Math.abs(resizeHeight - originalHeight) < 10) {
      callback(false)
    } else {
      callback(true)
    }
  })
  window.addEventListener('focusin', () => {  //软键盘弹起事件
    callback(true);
  })
  window.addEventListener('focusout', () => { //软键盘关闭事件
    callback(false);
  })
}

export default function CommunityDetail(props) {

  const [loading, setLoading] = useState(false)
  const [info, setInfo] = useState()
  const [comments, setComments] = useState([])
  const [total, setTotal] = useState(0)
  const [like, setLike] = useState(false)
  const [like_count, setLike_count] = useState()
  const [rid, setRid] = useState('')
  const [name, setName] = useState()
  const [sort, setSort] = useState({ text: '最新回复', key: 'new_reply' })
  const [top, setTop] = useState(0)
  const inputRef = useRef()
  const id = props.query.id
  const tagid = props.query.tagid
  const circles_type = props.query.circles_type
  const topic_id = props.query.topic_id
  const [loaded, setLoaded] = useState(false)
  const [visible, setVisible] = useState(false)
  const [praiseVisible, setPraiseVisible] = useState(false)
  const [user, setUser] = useActiveState('user')
  const [isCheckAuth, setIsCheckAuth] = useState(false)
  const [page, setPage] = useState(1)
  const [more, setMore] = useState(false)
  const [cachePublish_from_game, setCachePublish_from_game] = useLocalStorageState('publish_from_game', {})

  const contentRef = useRef()
  const imageViewerRef = useRef()
  const [imageSrcs, setImageSrcs] = useState([]); // 所有图片地址（用于切换）
  const [imageVisible, setImageVisible] = useState(false); // 控制图片查看器显示

  useEffect(() => {
    if (props.active && contentRef.current && info) {
      const images = contentRef.current.querySelectorAll('img');      
      const srcs = [];
      
      // 收集所有图片地址
      images.forEach(img => {
        const src = img.getAttribute('src');
        if (src) {
          srcs.push(src);
        }
      });
      setImageSrcs(srcs); // 设置图片地址列表
      // 定义点击处理函数
      const handleImageClick = (event) => {
        event.preventDefault(); 
        
        const src = event.target.getAttribute('src');
        if (src) {
          const index = srcs.indexOf(src); // 找到当前点击图片的索引
          if (index !== -1) {
            imageViewerRef.current.swipeTo(index, false);
            setImageVisible(true); // 显示 ImageViewer
          }
        } else {
            // Toast.show({ content: '图片地址无效' });
        }
      };

      // 为每个图片添加监听器
      images.forEach(img => {
        img.style.cursor = 'pointer';
        img.addEventListener('click', handleImageClick);
      });

      // 清理函数
      return () => {
        images.forEach(img => {
          img.removeEventListener('click', handleImageClick);
        });
      };
    }
  }, [ props.active, contentRef.current, info]);


  const sorts = [
    {
      text: '最新回复',
      key: 'new_reply'
    },
    {
      text: '最早回复',
      key: 'early'
    },
    {
      text: '最热回复',
      key: 'hottest'
    }
  ]

  const tagidDiv = () => {
    if (parseInt(tagid) === 1) {
      return '评论详情'
    } else if (parseInt(tagid) === 2) {
      return '攻略详情'
    } else if (parseInt(tagid) === 3) {
      return '问答详情'
    } else if (parseInt(tagid) === 4) {
      return '活动详情'
    } else {
      return '帖子详情'
    }
  }

  useEffect(() => {
    if (props.active && tagid) {
      props.setTitle(<div>{tagidDiv()}</div>)
      if (parseInt(tagid) == 4 || parseInt(tagid) == 2) {
        props.setOperate(<NavLink onClick={() => setVisible(true)}>
          <img src="resources/share.png" height={22} alt="" />
        </NavLink>)
      }
      getDetail({ loading: true })
    }
  }, [props.active, tagid])

  const scroll = useScroll()
  useEffect(() => {
    if (props.active) {

      setTimeout(() => {
        const newsort = document.getElementById('newsort')
        if (newsort) {
          setTop(newsort.getBoundingClientRect().top)
        }
      }, 500);
      if (scroll.top < -80) {
        getComment({ page: 1 })
      }
      if (scroll.top + window.innerHeight + 20 >= $(document).height() && more) {
        getComment({ page: page + 1 })
      }
    }
  }, [scroll, props.active])

  const getDetail = (params = {}) => {
    if (loading) {
      return
    }
    if (params.loading) {
      Dialog.loading()
    }
    setLoading(true)
    general.axios.post('/getCommunityInfo', { id, tagid, circles_type, topic_id })
      .finally(() => {
        setLoading(false)
        if (params.loading) {
          Dialog.close()
        }
      })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setInfo(data)
          setLike(data.me_like === '1')
          setLike_count(data.like_count)
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  const getComment = (params = {}) => {
    if (loading) {
      return
    }
    const pagination = {}
    if (params.page) {
      pagination.page = params.page,
        pagination.count = 10
    }
    setLoading(true)
    Dialog.loading()
    general.axios.post('/getCommunityListForComment', {
      tagid,
      id,
      sort: sort.key,
      circles_type,
      topic_id,
      pagination
    })
      .finally(() => {
        setLoading(false)
        Dialog.close()
      })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setComments(params.page && params.page > 1 ? [...comments, ...data.comment_list] : data.comment_list)
          params.page && setPage(params.page)
          setMore(data.paginated.more && data.comment_list.length > 0)
          setTotal(data.paginated.total)
          setLoaded(true)
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  const likeAction = () => {
    if (like) {
      return
    }
    general.axios.post('/likeUpvoteCommunity', { tagid, id, circles_type, tab: parseInt(tagid) === 3 ? 'question' : '' })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setLike(true)
          let count = parseInt(like_count) + 1
          setLike_count(count)
          redux.dispatch({
            type: 'update_community_like_number',
            data: {
              community_like_number_id: info?.id,
              community_like_number: count
            }
          })
          Dialog.toast({
            icon: 'agree',
            content: '',
            duration: 1,
            mask: false,
            onClose: () => { },
          });
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  const keyUp = (e) => {
    if (e.keyCode === 13) {
      if (loading) {
        return
      }
      if (inputRef.current.value.length === 0) {
        return
      }
      comment()
    }
  }

  const commentAction = (id, name) => {
    setRid(id)
    setName(name)
    setTimeout(() => {
    }, 100);
    inputRef.current.focus()
  }

  const comment = () => {
    if (!general.isLogin()) {
      general.history.push('/verificode')
      return
    }
    setLoading(true)
    Dialog.loading()
    const params = {
      tagid: info.tagid,
      id: info.id,
      content: inputRef.current.value,
      reply_id: rid,
      circles_type,
      topic_id
    }
    inputRef.current.blur()
    general.axios.post('/communityForComment', params)
      .finally(() => {
        setLoading(false)
        Dialog.close()
      })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          inputRef.current.value = ''
          getComment({ page: 1 })
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    monitorSoftKeyboard(isUp => {
      if (isUp) {

      } else {
        setRid('')
        setName()
      }
    })
  }, [])

  // const sortAction = (e) => {
  //   setSortAlert(false)
  //   if (e.sort) {
  //     setSort(e)
  //   }
  // }

  useEffect(() => {
    getComment({ page: 1 })
  }, [sort])

  const communityClickDownOperate = () => {
    if (info.tagid == 4) {
      general.axios.post('/communityClickDownOperate', {
        topic_id: info?.topic_id,
      })
    }
  }

  const headerTagImg = () => {
    if (parseInt(tagid) === 1) {
      return 'comment'
    } else if (parseInt(tagid) === 2) {
      return 'strategy'
    } else if (parseInt(tagid) === 3) {
      return 'question'
    } else if (parseInt(tagid) === 4) {
      return 'activity'
    } else {
      return ''
    }
  }

  const handleJoinChat = () => {
    if (user.isCheckAuth && !user.isRealNameAuth) {
      setIsCheckAuth(true)
      return
    }
    general.axios.post('/base/yunxin/joinTeams', { topic_id: info.game_info.maiyou_gameid })
      .then(res => {
        const { data, status } = res.data
        if (status.succeed) {
          const { tid } = data.info
          general.history.push(`/chat?tid=${tid}`)
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  const collectCommunityData = ()=> {
    Dialog.loading()
    const tmp = {
      circles_type: info.circles_type,
      id: info.id,
      tagid: info.tagid,
      tab: '',
      action: info.is_collect ? 2 : 1
    }    
    general.axios.post('/collectCommunityData',tmp).finally(res=>{
      Dialog.close()
    }).then(res=>{
      const { data, status } = res.data
        if (status.succeed) {
          setInfo({...info,is_collect:tmp.action == 2 ? false : true})
          Dialog.info(data)
        }else {
          Dialog.error(status.error_desc)
        }
    })
  }

  return (
    <div className='community-detail'>
      {visible && <ShareAlert close={() => setVisible(false)} topic_id={info?.share_info?.maiyou_gameid} shareUrl={info?.share_info?.share_url} visible={visible} id={info?.id} subtype={info?.share_info?.subtype}></ShareAlert>}
      {loaded && <div className="container">
        <div className="detail-header">
          {info?.tagid != 0 && <div className="type">
            <img src={"resources/community/icon_" + headerTagImg() + ".png"} alt="" />
          </div>}

          {info?.title ? <div className="title">{info?.title}</div> : null}

          {info?.game_info?.maiyou_gameid && <div style={{ paddingTop: 10 }}>
            <div style={{ backgroundColor: '#F8F8F8', border: '1px solid #E6E6E6', borderRadius: 13, padding: 10, display: 'flex', alignItems: 'center' }}>
              <NavLink user={false} to={'/game?id=' + info?.game_info?.game_id}>
                <img src={info?.game_info?.game_image?.thumb} alt="" height={48} />
              </NavLink>
              <NavLink user={false} to={'/game?id=' + info?.game_info?.game_id} style={{ flex: '1', paddingLeft: 10 }}>
                <div>
                  <div style={{ fontSize: 14, color: '#282828', fontWeight: 500 }}>{info?.game_info?.game_name}</div>
                  <div style={{ fontSize: 10, color: '#666', paddingTop: 3 }}>{info?.game_info?.description}</div>
                </div>
              </NavLink>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <NavLink user={false} to={'/game?id=' + info?.game_info?.game_id} onClick={communityClickDownOperate} style={{ backgroundColor: 'var(--MainColor)', color: 'white', padding: '3px 16px', borderRadius: '14px' }}>下载</NavLink>
                {info?.game_info?.is_open_cluster && <NavLink onClick={handleJoinChat} style={{ backgroundColor: 'var(--MainColor)', color: 'white', padding: '3px 16px', borderRadius: '14px', marginLeft: '5px' }}>加群</NavLink>}
              </div>
            </div>
          </div>}

          {info?.announce_info?.maiyou_gameid && <div style={{ paddingTop: 10 }}>
            <div style={{ backgroundColor: '#F8F8F8', border: '1px solid #E6E6E6', borderRadius: 13, padding: 10, display: 'flex', alignItems: 'center' }}>
              <img src={info?.announce_info?.game_image?.thumb} alt="" height={48} />
              <div style={{ flex: '1', paddingLeft: 10 }}>
                <div style={{ fontSize: 14, color: '#282828', fontWeight: 500 }}>{info?.announce_info?.game_name}</div>
                <div style={{ fontSize: 10, color: '#666', paddingTop: 3 }}>{info?.announce_info?.description}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => {
                setCachePublish_from_game(info?.announce_info);
              }}>
                <NavLink onClick={e => {
                  if (user.isCheckAuth && !user.isRealNameAuth) {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsCheckAuth(true)
                    return
                  }
                }} to={'/publish?tagid=' + info.announce_info?.tagid + '&topic_id=' + info.announce_info?.topic_id + '&is_display_activetab=' + info?.announce_info?.is_display_activetab} style={{ backgroundColor: 'var(--MainColor)', color: 'white', padding: '3px 16px', borderRadius: '14px' }}>去发布</NavLink>
              </div>
            </div>
          </div>}

          <div className="userinfo">
            <Avatar className='avatar' src={info?.user_icon} />
            <div className="content">
              <div className="username">
                {info?.user_nickname}
                <img src={info?.honor_icon} alt="" width={24} style={{ marginLeft: '5px' }} />
              </div>
              <div className="time" style={{ display: info ? '' : 'none' }}>{info?.join_days} • {(() => {
                var date = new Date(info?.time * 1000)
                let Y = date.getFullYear()
                let M = date.getMonth() + 1
                let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
                let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
                var time = Y + '-' + M + '-' + D
                if (time === moment().format('YYYY-MM-DD')) {
                  return '今日 ' + H + m;
                } else if (time == moment().subtract(1, 'd').format('YYYY-MM-DD')) {
                  return '昨日 ' + H + m;
                } else {
                  return M + '月' + D + '日' + H + m
                }
              })()} • IP {info?.ip_location ? info?.ip_location.province : '未知'}</div>
            </div>
          </div>
          {info?.video?.length > 0 ? <div className="video">
            <Player
              aspectRatio='16:9'
              poster={info?.video_img_url}
              height={'auto'}
              autoPlay={true}
              playsInline={true}
              src={info.video}
            >
              <Shortcut></Shortcut>
              <BigPlayButton position='center'></BigPlayButton>
              <ControlBar autoHide={true}></ControlBar>
            </Player>
          </div> : null}
          {info?.pic_list?.length > 1 ?
            <div className="imgs">
              {info?.pic_list?.map((img, index, imgs) => <Link to={'/img?imgs=' + img + '&img=' + index} className="img"><Image src={img} alt="" /></Link>)}
            </div> : null}
          {info?.pic_list?.length === 1 ?
            <div className="wap">
              <Link to={'/img?imgs=' + info.pic_list[0] + '&img=0'} className="img"><Image className='image' src={info.pic_list[0]} alt="" /></Link>
            </div> : null}
          <div ref={contentRef} className="contents" dangerouslySetInnerHTML={{ __html: info?.content }}></div>
          {info?.reward.button && <div className="price">
            <div style={{ display: 'flex', alignItems: 'stretch', justifyContent: 'center', paddingTop: '40px' }}>
              <img src="resources/251009/left.png" alt="" height={9} />
              <div style={{ fontSize: '13px', color: '#666', padding: '0 10px' }}>{info?.reward?.title}</div>
              <img src="resources/251009/left-right.png" alt="" height={9} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '30px' }}>
              <NavLink onClick={() => setPraiseVisible(true)} style={{ backgroundColor: 'var(--MainColor)', borderRadius: '16px', padding: '5px 18px', margin: '0 auto', display: 'flex', alignItems: 'center' }}>
                <img src="resources/251009/goid.png" alt="" height={22} />
                <span style={{ color: 'white', fontSize: '15px', paddingLeft: 5 }}>{info?.reward?.button}</span>
              </NavLink>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', width: info?.reward?.list.length * 10, minWidth: 14 }}>
                {info?.reward?.list.map((item, index) => (
                  <img src={item} alt='' style={{ border: '1px solid #D5D5D5', borderRadius: '7px', position: 'relative', left: -5 * index, position: 'relative', zIndex: index }} width={14} height={14} />
                ))}
              </div>
              {info?.reward?.list.length > 0 && <div style={{ fontSize: '13px', color: '#999', paddingLeft: 10 }}>{info?.reward?.tips}</div>}
            </div>
          </div>}
        </div>
        <div style={{ backgroundColor: '#F5F6F8', height: 8 }}></div>
        <div className="comments">
          <div className="toolbar">
            <div className="number">全部回复 {total}</div>

            <Popover.Menu
              getContainer={document.getElementById('root')}
              className='community-sorts'
              actions={sorts}
              mode={'dark'}
              placement='bottom-start'
              onAction={node => {
                setSort(node)
              }}
              trigger='click'>
              <div id='newsort' className="sort">
                <span>{sort.text}</span>
                <img src="resources/community/sort.png" alt="" />
              </div>
            </Popover.Menu>

          </div>
          <div className="list">
            {comments.map(item => {
              return <CommunityItem circles_type={circles_type} key={item.id} item={item} reply={true} commentAction={commentAction}></CommunityItem>
            })}
          </div>
          {comments?.length === 0 && info ? <div className="empty"><img src="/resources/game/detail-commont-place.png" alt="" />暂无回复，抢个沙发哦~</div> : null}
        </div>
        <div className="comment-reply">
          <NavLink className="input">
            <input ref={inputRef} onFocus={() => {
              if (!general.isLogin()) {
                inputRef.current.blur()
              }
            }} enterkeyhint="send" placeholder={name ? '回复' + name : '到我发言了'} onKeyUp={keyUp} />
            <NavLink user={true}>
              <div className="like" onClick={collectCommunityData}>
                <img src={"resources/251222/" + (info?.is_collect ? "colleced" + '-' + BoxType + '.png' : "collec.png")} alt="" height={16} />
                <div>收藏</div>
              </div>
            </NavLink>
            <NavLink user={true}>
              <div className="like" onClick={e => {
                if (general.isLogin()) {
                  likeAction()
                }
              }}>
                <img src={"resources/251009/" + (like ? "like.png" : "unlike.png")} alt="" height={16} />
                <div>{like_count}</div>
              </div>
            </NavLink>
          </NavLink>
        </div>
      </div>}
      {/* {sortAlert ?
        <ComnunitySort
          top={top}
          sortAction={sortAction}
          sortList={[
            {
              title: '最新回复',
              sort: 'new_reply'
            },
            {
              title: '最早回复',
              sort: 'early'
            },
            {
              title: '最热回复',
              sort: 'hottest'
            }
          ]}
        ></ComnunitySort> : null} */}
      <PraiseAlert
        info={info}
        visible={praiseVisible}
        handleClose={() => setPraiseVisible(false)}
        handleRewardCommunity={() => {
          getDetail({ loading: false })
        }}
      ></PraiseAlert>

      <AuthAlert isCheckAuth={isCheckAuth} onClose={() => setIsCheckAuth(false)} handleAuthSuccess={info => {
        setUser({ ...user, ...info })
      }}></AuthAlert>

      <ImageViewer.Multi
        ref={imageViewerRef}
        classNames={{ mask: 'community-image-viewer' }}
        getContainer={document.getElementById('root')}
        images={imageSrcs}
        visible={imageVisible}
        onClose={() => {
          setImageVisible(false)
        }}
      />
    </div>
  )
}
